import React, { useMemo } from 'react';
import { analyticsSnapshot, AnalyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const snapshot: AnalyticsSnapshot = analyticsSnapshot;

const AdsConversionsPage: React.FC = () => {
  const conversions = snapshot.webAnalytics.conversions;
  const goal = conversions.goals[0];
  const absoluteDataset = goal.datasets[0];
  const rateDataset = goal.datasets[1];
  const revenue = conversions.revenue;

  const latestConversion = findLatestValue(absoluteDataset.data);
  const latestRate = findLatestValue(rateDataset.data);
  const latestRevenue = findLatestValue(revenue.datasets.data);
  const label = latestConversion.index >= 0 ? goal.labels[latestConversion.index] : 'Veri yok';
  const aiConversions = ((analyticsSnapshot as any).aiAnalysis?.webAnalytics?.conversions ?? {}) as any;
  const goalInsights = (aiConversions.goals?.[0]?.insights ?? []) as ReadonlyArray<any>;
  const revenueInsights = (aiConversions.revenue?.insights ?? []) as ReadonlyArray<any>;

  const conversionsChartData = useMemo<ChartData<'line'>>(
    () => ({
      labels: Array.from(goal.labels),
      datasets: [
        { label: absoluteDataset.label, data: Array.from(absoluteDataset.data) },
        { label: `${rateDataset.label} (%)`, data: Array.from(rateDataset.data) }
      ]
    }),
    [goal.labels, absoluteDataset, rateDataset]
  );

  const revenueChartData = useMemo<ChartData<'line'>>(
    () => ({
      labels: Array.from(revenue.labels),
      datasets: [
        {
          label: `Gelir (${revenue.currency})`,
          data: Array.from(revenue.datasets.data)
        }
      ]
    }),
    [revenue.labels, revenue.datasets.data, revenue.currency]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Reklam Dönüşüm Performansı</h1>
          <p className="text-white/70 mt-2">
            Dönüşüm hedefleri, dönüşüm oranları ve gelir katkısı üzerinden reklam yatırımlarını değerlendirin.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{label}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <MetricSummary
          title="Dönüşüm Sayısı"
          value={latestConversion.value}
          description="Son ay tamamlanan dönüşüm sayısı."
        />
        <MetricSummary
          title="Dönüşüm Oranı"
          value={latestRate.value}
          unit="percentage"
          description="Son ay dönüşüm oranı."
        />
        <MetricSummary
          title="Gelir"
          value={latestRevenue.value}
          unit="currency"
          currency={revenue.currency}
          description="Son ay reklam kaynaklı gelir."
        />
      </div>

      <ChartCard
        title="Aylık Dönüşüm Trendleri"
        description="Tamamlanan dönüşümler ve dönüşüm oranının ilerleyişi."
        data={conversionsChartData}
        chartType="line"
        insights={goalInsights}
      />

      <ChartCard
        title="Gelir Trendleri"
        description="Reklam kaynaklı gelirin aylık değişimi."
        data={revenueChartData}
        chartType="line"
        insights={revenueInsights}
      />

    </div>
  );
};

export default AdsConversionsPage;

